export const privacyContent = {
  sections: [
    {
      title: "Welcome",
      content: `Welcome to Jacks! Jacks App Inc. ("Jacks," "we," "our," or "us") respects your privacy and is committed to safeguarding the personal information you share with us. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you use our Services, including the Jacks app, website, and associated platforms (collectively, the "Services").

By accessing or using our Services, you agree to the practices described in this Privacy Policy. This policy has been updated as of the effective date above to comply with industry standards, Apple guidelines, and applicable privacy laws.`
    },
    {
      title: "1. Information We Collect",
      content: `We collect the following types of information to operate effectively and provide a safe, seamless experience:

A. Information You Provide Directly
   •   Account Registration: Your name, email address, phone number, profile photo, and password when creating an account.
   •   Date of Birth: To verify age eligibility and tailor app functionality to comply with legal requirements.
   •   Selfie Upload: To confirm your identity and enhance security for sensitive or regulated services. For details about face data collection, usage, and retention, refer to Section 3.
   •   Driver Information: For drivers, we collect your driver's license, proof of insurance, vehicle registration, and inspection details to verify your eligibility and ensure safety compliance.
   •   Payment Information: For payments and payouts, we collect billing details, credit/debit card numbers, and other financial data through secure third-party payment processors.
   •   Communications: Records of your correspondence with us, including inquiries and feedback.



   B. Automatically Collected Information
   •	Device Information: Information about your device, such as type, operating system, IP address, and unique identifiers.
   •	Geolocation: Precise location data to facilitate driver-client connections and enhance service functionality.
   •	Usage Information: Data on your interactions with our Services, including features accessed, pages viewed, and session duration.

C. Information from Third Parties
   •	Background Checks: For drivers, we use third-party services to conduct background and driving record checks.
   •	Social Media Integration: If linked, we may access certain profile information based on your privacy settings.
   •	Partner Platforms: Information from car rental companies, corporate partners, or other third-party services you engage with through Jacks.

2. How We Use Your Information

We use the information we collect to:
   •	Provide and Manage Services: Facilitate connections between drivers and customers, process payments, and deliver requested features.
   •	Ensure Safety and Security: Verify identities, conduct background checks, and monitor for fraudulent activity.
   •	Personalize Your Experience: Tailor our Services to your preferences and booking history.
   •	Communicate With You: Send service-related updates, respond to inquiries, and share promotional content (if opted-in).
   •	Comply With Legal Obligations: Meet regulatory requirements and other compliance obligations.

3. How We Use, Disclose, and Retain Face Data

We collect, use, and store your selfie for identity verification and security purposes. This ensures a safe experience, particularly for sensitive services.
   •	Collection: Selfies are used to confirm identity and protect against fraud.
   •	Usage: Limited to authentication, driver-client matching, and security enhancements.
   •	Disclosure: Face data is not shared with third parties unless required by law or with your explicit consent.
   •	Retention: Selfies are securely stored and retained only as long as necessary for the purposes outlined or as required by law.

4. Location Services

Jacks uses your location data to:
   •	Facilitate driver and customer connections.
   •	Provide accurate service suggestions based on your location.
   •	Optimize trip routing and enhance service efficiency.

We only collect your location while you actively use the app or if you’ve granted background location permissions to improve service availability. You can adjust these settings in your device preferences, but disabling location services may limit certain functionalities.

5. Why We Collect Driver and Vehicle Information

For drivers and clients, we collect driver’s licenses, proof of insurance, vehicle registration, and inspection details to:
   •	Verify Eligibility: Ensure compliance with legal and safety standards.
   •	Enable Services: Confirm that drivers and vehicles meet operational requirements.
   •	Enhance Safety: Maintain transparency and accountability for trips where drivers operate the client’s personal or rental vehicle.

6. Data Collection and Storage

We securely collect and store your data to provide essential app functionality, improve our services, and comply with legal obligations.
   •	Data Encryption: All personal and financial data is encrypted during transmission and storage.
   •	Access Controls: We limit access to your data to authorized personnel only.
   •	Storage Duration: Personal data is stored only as long as necessary for service delivery or legal compliance.

You can request further details about our data collection and storage practices by contacting privacy@jacks.com.co.

7. How We Share Your Information

We share your information only as necessary:
   •	With Service Providers: For payment processing, background checks, analytics, and customer support.
   •	For Legal Obligations and Safety: When required by law or to protect the rights, safety, or property of users and the public.
   •	In Business Transactions: During mergers, acquisitions, or asset sales, your data may be transferred to the successor entity.
   •	With Your Consent: For additional purposes if you provide explicit approval.

8. Cookies and Tracking Technologies

We use cookies and similar technologies to enhance your experience:
   •	Essential Cookies: Enable core functionality.
   •	Performance Cookies: Improve site performance and user experience.
   •	Marketing Cookies: Measure engagement with promotional efforts.

9. Data Retention

We retain your personal information only as long as necessary for the purposes outlined in this policy:
   •	Account Data: Until account deletion or as required by law.
   •	Transaction Records: Retained for seven years for compliance with financial laws.

10. Your Privacy Rights

Depending on your location, you may have rights to:
   •	Access: Review and update your information.
   •	Delete: Request account and data deletion via privacy@jacks.com.co.
   •	Opt-Out: Unsubscribe from promotional communications.
   •	Restrict Processing: Limit how your data is used.

11. Data Security

We employ encryption, access controls, and regular audits to protect your data. However, no method is completely secure. Please safeguard your account by using strong passwords and logging out after use.

12. Children’s Privacy

Our Services are not directed at individuals under 18. If we learn that a minor has provided personal information, we will delete it promptly.

13. International Users

Your data may be processed in jurisdictions with different privacy laws. By using our Services, you consent to such processing.

14. Changes to This Privacy Policy

We may update this policy periodically. Significant changes will be communicated through our app or website.

15. Contact Us

For questions or concerns, please reach out to us at:

Jacks App Inc.
228 Park Ave S #651386, New York, NY 10003
Email: privacy@jacks.com.co
Phone: (877) 774-1701

Thank you for trusting Jacks with your information!`
    },
  ]
};